import { Link } from 'react-router-dom';
import { PerchLogo } from '../ui/PerchLogo';

export function Footer() {
  return (
    <footer className="py-12 px-4 sm:px-6 bg-white dark:bg-stone-900 border-t border-stone-200/60 dark:border-stone-800/50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="md:flex-1">
            <PerchLogo />
          </div>

          <p className="text-sm text-stone-400 dark:text-stone-500">
            Built in NYC
          </p>

          <div className="md:flex-1 flex items-center justify-end gap-6 text-sm text-stone-500 dark:text-stone-400">
            <a href="mailto:saraswatayu@gmail.com" className="hover:text-stone-900 dark:hover:text-stone-100 transition-colors">
              Contact
            </a>
            <Link to="/privacy" className="hover:text-stone-900 dark:hover:text-stone-100 transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-stone-900 dark:hover:text-stone-100 transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
